import { useMutation } from 'react-query';
import { PublicSharedApiService } from 'shared/services/public-shared-api.service';
import { endpoint } from 'shared/services/shared-api.service';
import { UploadIdSubmissionParams } from './types';

const publicSharedApiService = new PublicSharedApiService(endpoint);

export const useUploadIdSubmission = () => {
  const mutationFn = (params: UploadIdSubmissionParams) => {
    return publicSharedApiService.create({
      path: 'public/id-submission/process',
      body: params,
    });
  };

  return useMutation({ mutationFn });
};
